export const PaidTypes: readonly string[] = ['Inteira', 'Meia', 'Único']

export const FreeTypes: readonly string[] = ['Cortesia', 'Gratuidade']

export const DefaultTypes: readonly string[] = [...PaidTypes, ...FreeTypes]
